module.exports = __webpack_public_path__ + "img/paygrade_Illustration.78431687.svg";